<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import browserTool from './utils/browser-tool.js'
export default {
  name: 'App',
  data() {
    return {}
  },
  created() {
    localStorage.clear()
    this.navigateTo()
  },
  methods: {
    // 判断跳转的页面
    navigateTo() {
      if (browserTool()) {
        this.$router.push({ path: '/h5' })
      } else {
        this.$router.push({ path: '/' })
      }
    }
  }
}
</script>

<style lang="scss">
@import 'scss/public';
</style>
